
import * as $ from 'jquery';
import { isApp, config } from "./utils.js";

// Reto Eco landing
window.addEventListener("DOMContentLoaded", async () => {

  if (document.body.classList.contains("js-reto-eco")) {

    const title = document.getElementById('share-reto-eco-title').content.children[0].innerText;
    const text = document.getElementById('share-reto-eco-text').content.children[0].innerText;
    const image = document.getElementById('share-reto-eco-img').content.children[0].src;
    const url = document.getElementById('share-reto-eco-url').content.children[0].innerText;

    // Share API (mobile native)
    const imgFetch = await fetch(image);
    const imgBlob = await imgFetch.blob();
    const files = [
      new File(
        [imgBlob],
        'reto-eco.jpg',
        {
          type: "image/jpeg",
          lastModified: new Date().getTime()
        }
      )
    ];

    const shareData = {
      title,
      text,
      url,
      files
    };

    document.querySelector('.js-share-action').addEventListener("click", function () {
        // If Share API available (mobile native)
        if (isApp() && navigator.canShare && navigator.canShare(shareData)) {
          navigator.share(shareData).catch(err => {
            if (err.name === 'AbortError') return; // El usuario canceló el diálogo de compartir
            throw err;
          });
        } else {
          $('#socialButtons').collapse('toggle');

          document.getElementById("whatsapp").addEventListener("click", function () {
            VanillaSharing.whatsapp({
              url,
              title,
            });
          });

          document.getElementById("facebook").addEventListener("click", function () {
            VanillaSharing.fbShare({
              url,
              redirectUri: shareData.url,
              hashtag: "#RetoEco",
              fbAppId: config.fbId,
              quote: text,
            });
          });

          document.getElementById("pinterest").addEventListener("click", function () {
            VanillaSharing.pinterest({
              url,
              description: text,
              media: image,
            });
          });

          document.getElementById("twitter").addEventListener("click", function () {
            VanillaSharing.tw({
              url,
              title,
              hashtags: ["RetoEco"],
            });
          });

          document.getElementById("email").addEventListener("click", function () {
            VanillaSharing.email({
              url,
              title,
              description: text,
              subject: title,
            });
          });
        }
    });

    document.querySelector('.js-copy-url-reto-eco').addEventListener('click', e => {
      const successAlert = document.querySelector('.js-success-copy');
      e.preventDefault();
      successAlert.classList.remove('d-none');
      successAlert.classList.add('d-inline-block');
      window.setTimeout(() => {
          successAlert.classList.add('d-none');
          successAlert.classList.remove('d-inline-block');
      }, 3000);
  })
  }
})
